import type { Policy } from '@/permissions/types';

export const taskCreationPolicies: Policy[] = [
  {
    name: 'create:task',
    evaluate: ({ user }) =>
      ['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'].includes(user.perfil),
  },
  {
    // Tasks proofread by the school itself (SaaS). Mirrors the Angular new-task page.
    name: 'create:school_corrected_task',
    evaluate: ({ user }) => user.perfil === 'COORDENADOR_SAAS',
  },
];
